'use client';

import BasePage from '@/components/BasePage';
import { WarningTarget } from '@/components/WarningBox';
import PreCheckOut from '@/containers/VoyagePlanner/PackageResults/PreCheckOut';
import PreCheckoutDataLoader from '@/containers/VoyagePlanner/PackageResults/PreCheckOut/DataLoader';
import useClearWarningOnAway from '@/features/warnings/hooks/useClearWarningOnAway';
import { useRecentSearchesSaver } from '@/hooks/useRecentSearchesSaver';

const PreCheckOutPageClient = () => {
  useRecentSearchesSaver();
  useClearWarningOnAway([WarningTarget.preCheckoutTop, WarningTarget.preCheckoutSecondary]);

  return (
    <BasePage>
      <PreCheckoutDataLoader>
        <PreCheckOut />
      </PreCheckoutDataLoader>
    </BasePage>
  );
};

export default PreCheckOutPageClient;
